/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { AuthService } from '../../services';
import { classNames, Constants, formatAmount, fromPhotos } from '../../utils';
import Render from '../../components/render';
import AcquirePlan from './acquire-plan';

const GetPlan = ({ onSuccess, onClose, initPayment }) => {
  const { form, onChangePlan, onSubmit, makePayment, plans, setMakePayment, user } = useForm(initPayment);

  return (
    <>
      <Render condition={makePayment}>
        <AcquirePlan
          user={user}
          plan={form.plan}
          initPayment={initPayment}
          onClose={() => setMakePayment(false)}
          onSuccess={() => onSuccess()}
        />
      </Render>

      <Modal size="md" backdrop="transparent" isOpen onClose={onClose}>
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">Planes</ModalHeader>
          <ModalBody className="gap-8 relative">
            <main className="flex gap-4 my-4 justify-center">
              {plans.map(plan => {
                const description = String(plan?.description ?? '')
                  .replace(':date', moment().add(1, 'week').format('DD/MM/YYYY'))
                  .replace(':price', '$' + formatAmount(plan?.price));

                return (
                  <div
                    key={plan.id}
                    className={classNames(
                      'rounded-xl p-2 cursor-pointer shadow-md',
                      form.plan_id === plan.id ? 'bg-[#C6FFDE]' : 'bg-white'
                    )}
                    onClick={() => onChangePlan(plan)}
                  >
                    <div className="flex justify-start items-start gap-4">
                      <div className="bg-[#3E82C3] p-2 rounded-lg">
                        <img className="w-7 h-7 object-contain" src={fromPhotos(plan?.icon)} alt="Plan" />
                      </div>

                      <div>
                        <p className="font-bold text-sm leading-4 mb-0">{ plan?.name }</p>
                        <p className="font-bold text-xl text-secondary mb-0">${ formatAmount(plan?.price) }</p>
                      </div>
                    </div>

                    <p className="mt-4 font-medium text-xs text-black whitespace-pre-line">
                      { description }
                    </p>
                  </div>
                )
              })}
            </main>
          </ModalBody>
          <ModalFooter>
            <Button variant="light" onPress={onClose}>Cerrar</Button>
            <Button className="bg-green" color="primary" onPress={onSubmit} isDisabled={form.amount === 0}>
              Pagar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

const useForm = () => {
  const [form, setForm] = useState({
    plan_id: undefined,
    plan: null,
    amount: 0,
  });
  const [plans, setPlans] = useState([]);
  const [makePayment, setMakePayment] = useState(false);
  const user = useSelector((state) => state.user);

  const getPlans = async () => {
    try {
      const selects = await AuthService.getSelects();
      const planType = user.level_id === Constants.USER.LEVELS.SCHOOL
        ? Constants.PLAN_FOR.SCHOOL
        : Constants.PLAN_FOR.TEACHER;
      setPlans(selects.plans.filter(x => x.for === planType && x.price > 0));

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const onChangePlan = (plan) => {
    onChange(plan.id, 'plan_id');
    onChange(plan.price, 'amount');
    onChange(plan, 'plan');
  }

  const submit = async () => {
    if (form.amount === 0) {
      toast.error('Debe seleccionar un plan');
      return false;
    }
    setMakePayment(true);
  }

  useEffect(() => {
    getPlans();
  }, []);

  return {
    form,
    makePayment,
    onChange,
    onChangePlan,
    onSubmit: submit,
    plans,
    setMakePayment,
    user,
  }
}

export default GetPlan;
